import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { useIntl, MessageDescriptor } from 'react-intl'
import List from 'components/shared/List'
import { Fragment } from 'react'
import {
    ZonesCategoryBadge,
    ZonesCategoryIcon,
    ZonesCategoryInfo,
    ZonesCategoryList,
    ZonesModalCategoryWrapper,
} from './styles'
import 'swiper/css'
import ZonesCategorySlider from './components/ZonesCategorySlider'

export interface BulletsMessages {
    [key: string]: MessageDescriptor
}
export interface BulletsValues {
    [key: string]: string
}

interface ZonesModalCategoryProps {
    iconUrl: string
    zoneName: React.ReactNode
    hasAgeBadge?: boolean
    shortDescription: React.ReactNode
    bullets: BulletsMessages
    bulletsValues?: BulletsValues
    images: string[]
}

const ZonesModalCategory = ({
    iconUrl: iconSrc,
    zoneName,
    hasAgeBadge,
    shortDescription,
    bullets,
    bulletsValues,
    images,
}: ZonesModalCategoryProps) => {
    const { formatMessage } = useIntl()

    return (
        <ZonesModalCategoryWrapper direction={['column', 'row']} gap={[16, 24]}>
            <ZonesCategoryInfo>
                <Box gap={4}>
                    <ZonesCategoryIcon src={iconSrc} alt={`${zoneName} logo`} />
                    <Box direction="row" align="center" gap={12}>
                        <Text variant="heading3" color="secondary_500">
                            {zoneName}
                        </Text>
                        {hasAgeBadge && (
                            <ZonesCategoryBadge
                                variant="bodyExtraSmall"
                                color="secondary_500"
                            >
                                16+
                            </ZonesCategoryBadge>
                        )}
                    </Box>
                    <Text variant="body14" color="grayscale_800">
                        {shortDescription}
                    </Text>
                </Box>
                <ZonesCategoryList gap={[6, 4]}>
                    <List gap={4}>
                        {Object.keys(bullets).map((key) => {
                            const entryData = bullets[key]

                            return (
                                <Fragment key={key}>
                                    {formatMessage(entryData, {
                                        span: (chunks: string[]) => (
                                            <Text
                                                as="span"
                                                variant="bodySmall"
                                                color="grayscale_800"
                                            >
                                                {chunks}
                                            </Text>
                                        ),
                                        ...bulletsValues,
                                    })}
                                </Fragment>
                            )
                        })}
                    </List>
                </ZonesCategoryList>
            </ZonesCategoryInfo>
            <ZonesCategorySlider images={images} alt={`${zoneName}`} />
        </ZonesModalCategoryWrapper>
    )
}

export default ZonesModalCategory
